import { useSelector } from "react-redux";

export const useGetSubscriptionTypeForProduct = (productId): number => {
    const productsInfo = useSelector(state => state.products);

    const product = productsInfo?.products?.find(p => p.id === productId);
    const subscriptionType = product?.order?.subscriptionTypeId?.[0];
    
    return subscriptionType;
};